/**
 * Consolidating check for quota
 * We consider having quota if any of the subscriptions have quota left
 */
export const hasQuota = (currentTileQuotas, currentSubIds) => {
  // on initial load we may not have subs, we should let the user view data.
  if (!currentSubIds.length) {
    return true;
  }
  // negative ids means it's a customer that gets access even without quota, like Tasking (-115)
  // https://hello.planet.com/jira/browse/PRODISSUE-480
  const letThemThrough = currentSubIds.some(id => id < 0);

  if (letThemThrough) {
    return true;
  }

  const hasOverage = currentTileQuotas.some(q => q.overage && q.limit > 0);
  const hasRemainingQuota = currentTileQuotas.some(
    q => q.remains > 0 && q.limit > 0
  );

  return hasOverage ? true : hasRemainingQuota;
};
